import React from 'react';
import Cashier from '../cashier';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Bet from '../bet';

const useStyles = makeStyles(() => ({
    root: {
        width: 'calc(100% - 40px)',     
        background: '#1b2039',
        borderRadius: '8px',
        padding: 20,
        marginTop: 12,
    },
    wrapTitle: {
        display: 'flex', 
        justifyContent: 'center'
    },
    title: {
        color: '#ffffff', 
        fontWeight: 700, 
        fontSize: 18
    },
    wtapTab: {
        display: 'flex', 
        flexDirection: 'column'
    },
    tab: {
        color: '#fff', 
        padding: '0 20px', 
        fontSize: 16, 
        fontWeight: 700, 
        paddingBottom: 10, 
        userSelect: 'none',
        cursor: 'pointer'
    },
    mt20: {
        marginTop: 20,
    }
}))

const Statistics = ({groups}) => {
    const classes = useStyles();
    const [active, setActive] = React.useState('bet');
    
    return (
        <div className={classes.root}>
            <div className={classes.wrapTitle}>
                <span className={classes.title}>Статистика</span>
            </div>
            <div className={classes.wrapTab}>
                <div>
                    <span
                        className={classes.tab}
                        style={{
                            borderBottom: active === 'bet' && '2px solid #FF005C', 
                        }}
                        onClick={() => setActive('bet')}    
                    >Ставки</span>
                    <span 
                        className={classes.tab}
                        style={{
                            borderBottom: active === 'cashier' && '2px solid #FF005C', 
                        }}
                        onClick={() => setActive('cashier')}  
                    >Касса</span>
                </div>
                <div className={classes.mt20}>
                    {
                        active === 'cashier' &&
                        <Cashier groups={groups}/>
                    }
                    {
                        active === 'bet' &&
                        <Bet groups={groups} />
                    }
                    
                </div>
            </div>
            
        </div>
    )
}

export default Statistics;